//import { initializeApp } from "firebase/app";
import firebase from "firebase/compat/app";

import "firebase/compat/auth";
import "firebase/compat/database";
import "firebase/compat/functions";
import "firebase/compat/app-check";
import "firebase/compat/analytics";
import "firebase/compat/storage";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { initializeApp } from "firebase/app";
// import {
//   getAI,
//   getGenerativeModel,
//   GoogleAIBackend,
//   Schema,
// } from "firebase/ai";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
// const {
//   initializeAppCheck,
//   ReCaptchaV3Provider,
// } = require("firebase/app-check");
// const { initializeApp } = require("firebase/app");

// //import { getDatabase, ref, onValue } from "firebase/database";

//import "firebase/firestore";

// used for authentication
//var database = firebase.database();
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
let config = {
  apiKey: "AIzaSyA_3M4Zks5OIVMFfGReEX2z-bordY0zoaI",
  authDomain: "circle-grid1.firebaseapp.com",
  projectId: "circle-grid1",
  storageBucket: "circle-grid1.firebasestorage.app",
  messagingSenderId: "126381495291",
  appId: "1:126381495291:web:7c3cb7235820d803d3b15e",
  // config for circle-grid
  //   apiKey: "AIzaSyBGwAR6njJSYcZtvBZfIu7vtuj0XD7PQbs",
  //   authDomain: "circle-grid.firebaseapp.com",
  //   projectId: "circle-grid",
  //   storageBucket: "circle-grid.firebasestorage.app",
  //   messagingSenderId: "533669214677",
  //   appId: "1:533669214677:web:3fac0d97880b187996a55c",
  //   measurementId: "G-1JMVJ07EK2",
};
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const appModular = initializeApp(config);
const app = firebase.initializeApp(config);

// const {
//   initializeAppCheck,
//   ReCaptchaEnterpriseProvider,
// } = require("firebase/app-check");
// Initialize Firebase
//const app = firebase.initializeApp(firebaseConfig);
//remove in production
//window.self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
//
//
// Provide a JSON schema object using a standard format.
// Later, pass this schema object into `responseSchema` in the generation config.
// const jsonSchema = Schema.object({
//   properties: {
//     characters: Schema.array({
//       items: Schema.object({
//         properties: {
//           id: Schema.string(),
//           account_group: Schema.string(),
//           vatType: Schema.string(),
//           // vatAmount: Schema.number(),
//           // species: Schema.string(),
//         },
//         //  optionalProperties: ["accessory"],
//       }),
//     }),
//   },
// });
// Initialize the Gemini Developer API backend service
//export const ai = getAI(appModular, { backend: new GoogleAIBackend() });

// Create a `GenerativeModel` instance with a model that supports your use case
// export const model = getGenerativeModel(ai, {
//   model: "gemini-2.0-flash", // In the generation config, set the `responseMimeType` to `application/json`
//   // and pass the JSON schema object into `responseSchema`.
//   generationConfig: {
//     responseMimeType: "application/json",
//     responseSchema: jsonSchema,
//   },
// });

const isLocalDevelopment =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";
// Firebase App Check enforcement also applies to Auth. For localhost, use
// Firebase's debug-token flow instead of sending an invalid production token.
if (isLocalDevelopment) {
  window.self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}
const appCheck = firebase.appCheck();
// Pass your reCAPTCHA v3 site key (public key) to activate(). Make sure this
// key is the counterpart to the secret key you set in the Firebase console.
appCheck?.activate(
  //'6LdVtn4rAAAAAPEk4D3CHS-kXv3DwWYMR5jBemzk',
  "6LdVtn4rAAAAAG356-Kho8kUcss9OZTQmr2lP5K_",

  // Optional argument. If true, the SDK automatically refreshes App Check
  // tokens as needed.
  true,
);

//Initialize App Check with reCAPTCHA v3
const appCheckModular = initializeAppCheck(appModular, {
  provider: new ReCaptchaV3Provider("6LdVtn4rAAAAAG356-Kho8kUcss9OZTQmr2lP5K_"),
  isTokenAutoRefreshEnabled: true, // recommended for production
});

// Create a ReCaptchaEnterpriseProvider instance using your reCAPTCHA Enterprise
// site key and pass it to initializeAppCheck().
// const appCheckModular = initializeAppCheck(appModular, {
//   provider:
//     new ReCaptchaEnterpriseProvider(/* reCAPTCHA Enterprise site key */),
//   isTokenAutoRefreshEnabled: true, // Set to true to allow auto-refresh.
// });
//export const database = firebase.database();
// Get a reference to the database service
export const database = firebase.database();
export const firestore = getFirestore(appModular);

//export const refs = ref;
//export const onValues = onValue;

//
//export const fireStoreDb = firebase.firestore();
export const auth = app.auth();
export const authM = getAuth(appModular);
//auth.useEmulator("http://localhost:9099");

export const functions = firebase.app().functions("us-central1");
export const COOKIE_CONSENT_KEY = "circlegrid_cookie_consent";

let analyticsInstance = null;

const analyticsAllowed = () => {
  try {
    return window.localStorage.getItem(COOKIE_CONSENT_KEY) === "analytics";
  } catch (error) {
    return false;
  }
};

const getAnalytics = () => {
  if (!analyticsAllowed()) return null;
  if (!analyticsInstance) {
    analyticsInstance = firebase.analytics();
    analyticsInstance.setAnalyticsCollectionEnabled(true);
  }
  return analyticsInstance;
};

// Keep the existing analytics.logEvent API, but do not initialise or write
// analytics data until the visitor has actively accepted analytics cookies.
export const analytics = {
  logEvent: (...args) => getAnalytics()?.logEvent(...args),
};

export const setAnalyticsConsent = (allowed) => {
  try {
    window.localStorage.setItem(
      COOKIE_CONSENT_KEY,
      allowed ? "analytics" : "essential",
    );
  } catch (error) {
    // The choice still applies for this page even if browser storage is blocked.
  }

  if (allowed) {
    getAnalytics();
  } else if (analyticsInstance) {
    analyticsInstance.setAnalyticsCollectionEnabled(false);
  }

  window.dispatchEvent(new Event("circlegrid-cookie-consent"));
};
export const storage = firebase.storage(app);

//export const Appfunctions = app.functions();
//removed export default app, may have to bring back
//export const app;

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
//reason for REACT_APP_FIREBASE_ before each config is react environmental variables must be prefixed with REACT_APP
